import { render, staticRenderFns } from "./webhooks-listing.vue?vue&type=template&id=9b805260&scoped=true&"
import script from "./webhooks-listing.vue?vue&type=script&lang=js&"
export * from "./webhooks-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b805260",
  null
  
)

export default component.exports